"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import { syncPostHogSessionRecording } from "@/lib/analytics/posthog-session-replay";

/**
 * Starts PostHog session replay only on allowlisted routes (D8 Option C).
 * Mount inside `PostHogProvider` so the client is initialized.
 */
export default function PostHogSessionReplayGate() {
  const pathname = usePathname();

  useEffect(() => {
    syncPostHogSessionRecording(posthog, pathname);
  }, [pathname]);

  return null;
}
